export var TITLE = 'Nova';
export var TEXT_MULTIPLE = 0.6;
export var SPACE_MULTIPLE = 0.1;
export var COLOR_PRIMARY = '#222F3E';
export var COLOR_GRADIENT = 'linear-gradient(135deg, #43E3E4, #4A9FFF, #AA4BFB, #FC5978, #FF6D32)';